import { useEffect } from 'react';
import BRAND from '../config/brand';

// Lightweight per-page SEO (title + meta description + OG) without extra deps.
export default function useMeta({ title, description }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${BRAND.name}` : `${BRAND.name} — ${BRAND.tagline}`;
    document.title = fullTitle;
    const desc = description || BRAND.description;
    const ensure = (selector, create) => {
      let el = document.head.querySelector(selector);
      if (!el) { el = create(); document.head.appendChild(el); }
      return el;
    };
    const metaDesc = ensure('meta[name="description"]', () => {
      const m = document.createElement('meta'); m.name = 'description'; return m;
    });
    metaDesc.content = desc;
    const ogTitle = ensure('meta[property="og:title"]', () => {
      const m = document.createElement('meta'); m.setAttribute('property', 'og:title'); return m;
    });
    ogTitle.content = fullTitle;
    const ogDesc = ensure('meta[property="og:description"]', () => {
      const m = document.createElement('meta'); m.setAttribute('property', 'og:description'); return m;
    });
    ogDesc.content = desc;
  }, [title, description]);
}
